import * as CoreModule from './core/core.module';
import * as FeaturesModule from './features/features.module';
import * as ComponentsModule from './components/components.module';
import * as LayoutModule from './layout/layout.module';
import * as ServicesModule from './services/services.module';

export const initialise = (keycloakInstance) => {
  ServicesModule.initialise();
  CoreModule.initialise(keycloakInstance);
  FeaturesModule.initialise();
  ComponentsModule.initialise();
  LayoutModule.initialise();

  /**
   * This is the 'main' root module for the application which depends on both the {@link app.core} and {@link app.features} modules being loaded.
   */
  angular.module('app', ['ui.router.upgrade', 'app.core', 'app.features'])
  .config(['$urlServiceProvider', $urlService => $urlService.deferIntercept()]);
};